<template>
  <div>
    <div class="theWrapPC">
      <banner></banner>
      <resource></resource>
      <cases></cases>
      <globalnetwork></globalnetwork>
      <customers></customers>
      <!-- <news></news> -->
      <partner></partner>
    </div>
    <div class="theWrapPhone">
      <div class="mob-banners">
        <swiper :options="mobBannerSwiper">
          <swiper-slide class="mob-slide banner-g">
            <div class="banner-main" style="cursor: pointer;" @click="enter('/solution/ComputePower')">
              <div class="compute-power-text">
                <img src="../../assets/home/newbanner/computepower/text.png" />
              </div>
              <img src="../../assets/home/newbanner/computepower/btn.png" class="compute-power-btn" />
            </div>
          </swiper-slide>
          <swiper-slide class="mob-slide page-c">
            <div @click="enter('/mobResource/idcJianDeNew')">
              <!-- <div class="jd-idc-title">
                浙西智算中心<br>
                三期大楼成功落地
              </div>
              <div class="jd-idc-sm-title">JIANDE TONGHANG CLOUD DATA CENTER</div>
              <button class="jd-idc-btn">了解更多</button> -->
            </div>
          </swiper-slide>
          <swiper-slide class="mob-slide page-a">
            <div @click="enter('/mobResource/netCCS')"></div>
            <!-- <div class="btns">
              <div
                class="mob-button mob-red"
                @click="
                  open({
                    itemName: '申请SD-WAN免费测试',
                    buType: 6,
                    items: ['description'],
                  })
                "
              >免费测试</div>
              <div class="mob-button" @click="watchVideo">观看视频</div>
            </div> -->
          </swiper-slide>
          <!-- <swiper-slide class="mob-slide page-b">
            <div @click="enter('/mobResource/netSDWAN')"></div>
          </swiper-slide> -->
          <swiper-slide class="mob-slide page-d">
            <div @click="enter('/mobResource/mdcDataCenter')"></div>
          </swiper-slide>
          <!-- <swiper-slide class="mob-slide page-e">
            <div @click="enter('/mobResource/mdcDataCenter')"></div>
          </swiper-slide> -->
        </swiper>
        <div class="pagination-wrap">
          <div class="mobbanner-pagination"></div>
        </div>
      </div>
      <h2 class="mob-tit">产品资源</h2>
      <p class="mob-addtit">提供安全可靠的资源与管理服务</p>
      <div class="mob-prodres">
        <div class="prodres-item" v-for="(item, index) in prodresItem" :key="index" @click="expProdRes(index)">
          <div class="item-top" :style="item.exp ? 'color:#CF111B' : ''">
            <div class="iconbox">
              <i :class="item.exp ? item.iconact : item.icon" :style="item.iconsize"></i>
            </div>
            <span class="tit">{{ item.tit }}</span>
            <i class="icondown iconfont mobicon-icon-test" :style="item.exp ? 'transform: rotateX(180deg) translateY(-50%);' : 'transform: rotateX(0deg) translateY(-50%);'"></i>
          </div>
          <div class="item-bot" :style="item.exp ? item.height : 'height:0'">
            <div class="bot-subitem" v-for="(subitem, subindex) in item.subitem" :key="subindex" @click="enter(subitem.suburl)">
              <p class="subtit">{{ subitem.subtit }}</p>
              <p class="subdesc">{{ subitem.subdesc }}</p>
            </div>
          </div>
        </div>
      </div>
      <h2 class="mob-tit">解决方案</h2>
      <p class="mob-addtit">打造一站式解决方案</p>
      <div class="mob-solution">
        <div class="solution-item" v-for="(item, index) in solutionItem" :key="index">
          <div class="iconbox">
            <i :class="item.icon" :style="item.iconsize"></i>
          </div>
          <h2 class="tit">{{ item.tit }}</h2>
          <div class="line"></div>
          <p class="desc">{{ item.desc }}</p>
          <!-- <div class="more">了解更多</div> -->
        </div>
      </div>
      <div class="mob-global">
        <h2 class="mob-tit" style="color: #fff; padding: 0.4rem 0 0.2rem;">全球网络</h2>
        <p class="mob-addtit" style="color: #fff;">提供优质便捷的服务</p>
        <div class="content">
          <div class="spot" style="left: 2.4rem; top: 3.9rem;"></div>
          <div class="spota" style="left: 2.7rem; top: 5.5rem;"></div>
          <div class="spotb" style="right: 4.1rem; top: 4.9rem;"></div>
          <div class="spot" style="right: 2.3rem; top: 4.1rem;"></div>
          <div class="spotc" style="right: 2rem; bottom: 1rem;"></div>
          <div class="spotc" style="right: 3.8rem; top: 3.3rem;"></div>
          <div class="sign" style="bottom: 4.1rem; right: 3.2rem;">
            <p>国内</p>
            <p style="font-weight: 600; font-size: 0.42rem;">100+</p>
          </div>
          <div class="sign" style="bottom: 3.6rem; left: 1.8rem;">
            <p>全球</p>
            <p style="font-weight: 600; font-size: 0.42rem;">180+</p>
          </div>
          <img src="../../assets/mobel/home/bar.png" class="bar" />
          <div class="textbox">
            <div class="text-item">
              <p class="num">100+</p>
              <p class="text">全球POP节点</p>
            </div>
            <div class="text-item">
              <p class="num">15+</p>
              <p class="text">覆盖国家及地区</p>
            </div>
          </div>
          <!-- <div class="spota" style="right: 4rem; bottom: 1rem;"></div> -->
        </div>
      </div>
      <h2 class="mob-tit">客户案例</h2>
      <p class="mob-addtit" style="margin-bottom: 0.1rem;">成功服务1200+企业客户</p>
      <ul class="mob-customers">
        <li class="customer-item" v-for="(item, index) in customerItem">
          <img :src="item.url" :style="item.size" />
        </li>
      </ul>
      <!-- <h2 class="mob-tit">社会责任</h2>
      <p class="mob-addtit">带您了解网银互联最新动态</p>
      <div class="mob-news">
        <div class="news-tab">
          <div
            :class="newsType == 0 ? 'tab-item act' : 'tab-item'"
            @click="
              newsType = 0;
              left = 'left:.2rem';
            "
          >产品动态</div>
          <div
            :class="newsType == 1 ? 'tab-item act' : 'tab-item'"
            @click="
              newsType = 1;
              left = 'left:3.4rem';
            "
          >企业动态</div>
          <div
            :class="newsType == 2 ? 'tab-item act' : 'tab-item'"
            @click="
              newsType = 2;
              left = 'left:6.6rem';
            "
          >行业动态</div>
          <div class="underline" :style="left"></div>
        </div>
        <div class="news-content" id="newswrap" v-if="newsType == 0">
          <div
            class="news-item"
            v-for="(item, index) in newsProd"
            :key="index"
            v-if="index < 4"
            @click="toDetail(item.id, 1)"
          >
            <div class="date-tit">
              <span class="date">{{ item. publishDate.slice(5, 10) }}</span>
              <span class="tit">{{ item.title }}</span>
            </div>
            <div class="desc">
              <p class="text">{{ item.articleAbstract }}</p>
            </div>
          </div>
        </div>
        <div class="news-content" id="newswrap" v-else-if="newsType == 1">
          <div
            class="news-item"
            v-for="(item, index) in newsEntp"
            :key="index"
            v-if="index < 4"
            @click="toDetail(item.id, 2)"
          >
            <div class="date-tit">
              <span class="date">{{ item. publishDate.slice(5, 10) }}</span>
              <span class="tit">{{ item.title }}</span>
            </div>
            <div class="desc">
              <p class="text">{{ item.articleAbstract }}</p>
            </div>
          </div>
        </div>
        <div class="news-content" id="newswrap" v-else-if="newsType == 2">
          <div
            class="news-item"
            v-for="(item, index) in newsIndu"
            :key="index"
            v-if="index < 4"
            @click="toDetail(item.id, 3)"
          >
            <div class="date-tit">
              <span class="date">{{ item. publishDate.slice(5, 10) }}</span>
              <span class="tit">{{ item.title }}</span>
            </div>
            <div class="desc">
              <p class="text">{{ item.articleAbstract }}</p>
            </div>
          </div>
        </div>
      </div> -->
      <h2 class="mob-tit">生态伙伴</h2>
      <p class="mob-addtit">赋能伙伴，共建未来生态</p>
      <div class="mob-partners">
        <swiper :options="mobPartnerSwiper" style="padding: 0.2rem 0;">
          <swiper-slide class="swiper-item">
            <img src="../../assets/home/partners/7中国电信1.png" style="height: 0.5rem;" />
          </swiper-slide>
          <swiper-slide class="swiper-item">
            <img src="../../assets/home/partners/liantong@2x.png" style="height: 0.7rem;" />
          </swiper-slide>
          <swiper-slide class="swiper-item">
            <img src="../../assets/home/partners/zhongguoyidong-caise@2x.png" style="height: 0.6rem;" />
          </swiper-slide>
          <swiper-slide class="swiper-item">
            <img src="../../assets/home/partners/中国铁通@2x.png" style="height: 0.8rem;" />
          </swiper-slide>
          <swiper-slide class="swiper-item">
            <img src="../../assets/home/partners/10长城宽带@2x.png" style="height: 0.7rem;" />
          </swiper-slide>
          <swiper-slide class="swiper-item">
            <img src="../../assets/home/partners/11教育网@2x.png" style="height: 0.6rem;" />
          </swiper-slide>
        </swiper>
      </div>
      <div v-if="videoFlag" class="video-outer" @click="watchVideo">
        <div class="video">
          <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>
        </div>
      </div>
    </div>
    <theForm ref="theForm"></theForm>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { Pagination, Loading } from "element-ui";
import theForm from "../../components/form";
import banner from "./components/banner";
import resource from "./components/resource";
import cases from "./components/cases";
import globalnetwork from "./components/globalnetwork";
import news from "./components/news";
import partner from "./components/partner";
import customers from "./components/customers";

export default {
  components: {
    banner,
    resource,
    cases,
    globalnetwork,
    news,
    partner,
    customers,
    swiper,
    swiperSlide,
    theForm,
    Pagination,
    Loading,
  },
  metaInfo: {
    title: "杭州网银互联科技股份有限公司",
    meta: [
      {
        name: "keyWords",
        content: "杭州网银互联科技股份有限公司",
      },
      {
        name: "description",
        content:
          "NetBank杭州网银互联科技股份有限公司（以下简称：网银互联）,是一家为全球企业提供IT管理、网络优化和云计算技术的服务商。秉承企业使命,打造了LinkCloud、MDC三大品牌业务线,以MSP服务、云网融合、定制IDC为核心业务,提供安全虚拟云主机、等保测评机构、IDC托管等服务，聚焦互联网新兴技术领域,为通讯、金融、文娱等不同领域一线企业提供整体的IT管理优化和服务。",
      },
    ],
    link: [
      {
        rel: "asstes",
        href: "https://www.netbank.cn/",
      },
    ],
  },
  mounted() {
    let loadingInstance = Loading.service({ target: "#newswrap" });
    this.dispatchExtend("getNetbankArticle", { type: "0", size: 4 }).then((result) => {
      this.newsProd = result.data.records || [];
      loadingInstance.close();
    });
    this.dispatchExtend("getNetbankArticle", { type: "1", size: 4 }).then((result) => {
      this.newsEntp = result.data.records || [];
      loadingInstance.close();
    });
    this.dispatchExtend("getNetbankArticle", { type: "2", size: 4 }).then((result) => {
      this.newsIndu = result.data.records || [];
      loadingInstance.close();
    });
  },
  data() {
    return {
      newsType: 0,
      newsProd: [],
      newsEntp: [],
      newsIndu: [], // 首页新闻数据集
      /**
       * @导航数据
       */
      prodresItem: [
        {
          tit: "算力服务",
          icon: "iconfont icon-suanli-samll",
          iconact: "iconfont  icon-suanli",
          iconsize: "font-size:0.58rem",
          height: "height:1.6rem", //per 1.35
          exp: false,
          subitem: [
            {
              subtit: "算力服务",
              subdesc: "一站式GPU算力资源池",
              suburl: "/resource/ComputePower",
            },
          ],
        },
        {
          tit: "IDC服务",
          icon: "iconfont mobicon-ITjichuziyuanyufuwu-01",
          iconact: "iconfont mobicon-ITjichuziyuanyufuwuhover-01",
          iconsize: "font-size:0.58rem",
          height: "height:7.5rem", //per 1.35
          exp: false,
          subitem: [
            {
              subtit: "数据中心服务",
              subdesc: "“拎包入住”式服务器托管",
              suburl: "/mobResource/mdcDataCenter",
            },
            {
              subtit: "服务模式",
              subdesc: "多种服务模式满足个性化需求",
              suburl: "/mobResource/mdcServiceModels",
            },
            {
              subtit: "标准 / 增值服务",
              subdesc: "一站式运维体系",
              suburl: "/mobResource/mdcStaVaServices",
            },
            {
              subtit: "IDC建设运营",
              subdesc: "集IDC设计规划、建设施工、运维管理、IDC产业园区一体化管理服务",
              suburl: "/mobResource/mdcCoop",
            },
            {
              subtit: "杭钢数据中心",
              subdesc: "国内唯一位于发达城市城区内的大型IDC",
              suburl: "/mobResource/mdcHangGang",
            },
          ],
        },
        {
          tit: "MDC网络融合服务",
          icon: "iconfont mobicon-wangluochanpinyufuwu-01",
          iconact: "iconfont mobicon-wangluochanpinyufuwuhover-01",
          iconsize: "font-size:0.58rem",
          height: "height:5.5rem", //per 1.35
          exp: false,
          subitem: [
            // {
            //   subtit: "全球组网",
            //   subdesc: "高效安全可靠的SD-WAN组网产品",
            //   suburl: "/mobResource/netSDWAN"
            // },
            {
              subtit: "云数据同步服务",
              subdesc: "灵活打通云上云下链接",
              suburl: "/mobResource/netCCS",
            },
            {
              subtit: "IDC数据同步服务",
              subdesc: "数据中心连接服务",
              suburl: "/mobResource/netDCS",
            },
            {
              subtit: "等级保护安全",
              subdesc: "为企业提供一站式全流程的等级服务",
              suburl: "/mobResource/cloudSafetyRule",
            },
            {
              subtit: "企业信息安全",
              subdesc: "提供纵向和横向两个维度的安全产品，保障企业信息安全",
              suburl: "/mobResource/cloudInfoSecurity",
            },
          ],
        },
        {
          tit: "其它服务",
          icon: "iconfont mobicon-yunjisuan",
          iconact: "iconfont mobicon-yunjisuanchanpinyufuwuhover-01",
          iconsize: "font-size:0.56rem",
          height: "height:6rem", //per 1.35
          exp: false,
          subitem: [
            {
              subtit: "云服务",
              subdesc: "为企业提供丰富的公有云资源和私有云建设服务",
              suburl: "/mobResource/cloudService",
            },
            {
              subtit: "混合云",
              subdesc: "帮助企业构建灵活、可靠的混合云架构",
              suburl: "/mobResource/cloudPass",
            },
            {
              subtit: "云架构设计咨询和迁移",
              subdesc: "为企业提供全流程一站式云MSP服务",
              suburl: "/mobResource/cloudMSP",
            },
            {
              subtit: "托管云",
              subdesc: "一款可定制化托管的混合及专有云平台",
              suburl: "/mobResource/cloudLinkCloud",
            },
          ],
        },
      ],
      solutionItem: [
        {
          icon: "iconfont icon-suanli",
          iconsize: "font-size:1.5rem",
          tit: "算力服务解决方案",
          desc: "在数据驱动的世界中，我们提供最先进GPU技术的算力资源池解决方案。从集群规划到运维维护，我们提供全套服务，帮助客户解锁AI、机器学习和大数据处理的潜力。",
          url: "",
        },
        {
          icon: "iconfont mobicon-rongqihuashuai",
          iconsize: "font-size:1.2rem",
          tit: "数据中心定制解决方案",
          desc: "高度个性化定制，满足多元化的需求。 曾仅耗时63天，为互联网龙头企业设计与建设整座数据中心。",
          url: "",
        },
        {
          icon: "iconfont mobicon-zhinengzuwangtiyan",
          tit: "机房搬迁服务解决方案",
          iconsize: "font-size:1.8rem",
          desc: "平滑迁移IT设备，高效安全，风险可控",
          url: "",
        },
        {
          icon: "iconfont mobicon-qiyeanquanfengxian",
          iconsize: "font-size:1.2rem",
          tit: "等保测评解决方案",
          desc: "等保2.0如期而至，网银互联依为客户提供一站式的等保测评解决方案， 帮助客户快速、低成本完成安全整改，轻松满足等保合规要求",
          url: "",
        },
      ],
      customerItem: [
        {
          size: "height:.75rem",
          url: require("../../assets/mobel/home/logo1.png"),
        },
        {
          size: "height:.75rem",
          url: require("../../assets/mobel/home/logo2.png"),
        },
        {
          size: "height:.8rem",
          url: require("../../assets/mobel/home/logo3.png"),
        },
        {
          size: "height:.45rem",
          url: require("../../assets/mobel/home/logo4.png"),
        },
        {
          size: "height:.8rem",
          url: require("../../assets/mobel/home/logo5.png"),
        },
        {
          size: "height:.7rem",
          url: require("../../assets/mobel/home/logo6.png"),
        },
        {
          size: "height:.4rem",
          url: require("../../assets/mobel/home/logo7.png"),
        },
        {
          size: "height:.7rem",
          url: require("../../assets/mobel/home/logo8.png"),
        },
        {
          size: "height:1rem",
          url: require("../../assets/mobel/home/logo9.png"),
        },
      ],
      /**
       * @移动端轮播图参数对象
       */
      left: "left:.2rem",
      mobBannerSwiper: {
        // autoplay: {
        //   delay: 4000,
        //   disableOnInteraction: false
        // },
        effect: "fade",
        loop: true,
        pagination: {
          el: ".mobbanner-pagination",
          type: "bullets",
          clickable: true,
        },
      },
      mobPartnerSwiper: {
        slidesPerView: 4,
        spaceBetween: 15,
        autoplay: {
          disableOnInteraction: false,
        },
        loop: true,
      },
      /**
       * @视频组件参数对象
       */
      videoFlag: false,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "https://file.netbank.cn/sdwanVideo.mp4", //url地址
          },
        ],
        // poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },

  methods: {
    enter(url) {
      console.log(123);
      if (url) {
        let a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("id", "startTelMedicine");
        // 防止反复添加
        if (document.getElementById("startTelMedicine")) {
          document.body.removeChild(document.getElementById("startTelMedicine"));
        }
        document.body.appendChild(a);
        a.click();
      }
    },
    open(data) {
      this.$refs.theForm.open(data);
    },
    expProdRes(index) {
      let sts = this.prodresItem[index].exp;
      this.prodresItem.forEach((element) => {
        element.exp = false;
      });
      this.prodresItem[index].exp = !sts;
    },
    watchVideo() {
      this.videoFlag = !this.videoFlag;
    },
    toDetail(id) {
      let routeData = this.$router.resolve({
        path: "/about/NewsDetail",
        query: { id: id },
      });
      window.open(routeData.href);
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-loading-spinner .path {
  stroke: #b81c22;
}

@import "../../style/variable.less";

@media screen and(min-width:@sm_min) {
  .theWrapPhone {
    display: none;
  }
}

@media screen and (min-width: @phone) and (max-width: @xs) {
  .theWrapPC {
    display: none;
  }

  .theWrapPhone {
    background: #f8f8f8;

    .mob-banners {
      width: 100%;
      height: 6.4rem;

      .page-a {
        background: #fff;
        background-repeat: no-repeat;
        // background-size: 11.25rem 6.4rem;
        background-position: center;
        text-align: center;
        background-size: cover;
        background-image: url("../../assets/mobel/home/banner1.jpg");

        > div {
          width: 100%;
          height: 6.4rem;
        }
      }

      .page-b {
        // padding-top: 2rem;
        // padding-left: 1.2rem;
        // color: #333;
        // .p1 {
        //   font-size: 0.65rem;
        //   margin-bottom: 0.25rem;
        // }
        // .p2 {
        //   font-size: 0.4rem;
        //   margin-bottom: 0.25rem;
        // }
        // .p3 {
        //   font-size: 0.38rem;
        //   margin-bottom: 0.25rem;
        // }
        background: #fff;
        background-repeat: no-repeat;
        background-position: center;
        text-align: center;
        background-size: cover;
        background-image: url("../../assets/mobel/home/banner2.jpg");

        > div {
          width: 100%;
          height: 6.4rem;
        }
      }

      .page-c {
        background-repeat: no-repeat;
        background: #fff;
        padding-top: 0.5rem;
        padding-left: 0.5rem;
        text-align: left;
        background-size: cover;
        background-position: center;
        background-image: url("../../assets/mobel/home/banner_wechat.jpg");
        // background-image: url("../../assets/mobel/solution/solSaaSApp/banner.png");

        > div {
          width: 100%;
          height: 6.4rem;
        }
      }

      .page-d {
        background: #fff;
        background-repeat: no-repeat;
        background-position: center;
        text-align: center;
        background-size: cover;
        width: 100%;
        background-image: url("../../assets/mobel/home/banner4.jpg");

        > div {
          width: 100%;
          height: 6.4rem;
        }
      }

      .page-e {
        background: #0e117d;
        background-repeat: no-repeat;
        // background-size: auto 6.4rem;
        background-position: center;
        text-align: center;
        background-size: cover;
        background-image: url("../../assets/mobel/home/banner5.jpg");

        > div {
          width: 100%;
          height: 6.4rem;
        }
      }

      .banner-g {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        background-image: url("../../assets/home/newbanner/computepower/bg.png");
        padding-left: 0.8rem;
        .compute-power-text {
          margin-top: 1.8rem;
          img {
            height: 1.4rem;
          }
        }
        .compute-power-btn {
          margin-top: 0.5rem;
          height: 0.5rem;
        }
      }

      .mob-slide {
        height: 6.4rem;
      }
    }

    .mob-prodres {
      .prodres-item {
        .item-top {
          height: 1.25rem;
          border: 1px solid #e1e1e1;
          border-top: none;
          background: #fff;
          padding: 0 0.66rem;
          position: relative;

          .iconbox {
            width: 0.7rem;
            height: 0.59rem;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
          }

          .tit {
            line-height: 1.25rem;
            margin-left: 0.9rem;
            font-size: 0.37rem;
          }

          .icondown {
            font-size: 0.5rem;
            position: absolute;
            transition: 0.3s;
            right: 0.66rem;
            top: 50%;
            transform-origin: top;
          }
        }

        .item-bot {
          background: #f8f8f8;
          transition: 0.3s;
          overflow: hidden;

          .bot-subitem {
            padding: 0.24rem 0.66rem;

            .subtit {
              color: #333;
              font-size: 0.36rem;
              margin-bottom: 0.1rem;
            }

            .subdesc {
              color: #999;
              font-size: 0.34rem;
              transform: scale(0.99);
            }
          }
        }

        &:nth-of-type(1) {
          .item-top {
            border-top: 1px solid #e1e1e1;
          }
        }
      }
    }

    .mob-solution {
      padding: 0.2rem;

      .solution-item {
        width: 8.7rem;
        // height: 8.7rem;
        height: 7.3rem;
        padding: 0.74rem 0.33rem 0.4rem;
        border: 0.5px solid #e1e1e1;
        margin: 0 auto;
        margin-bottom: 0.2rem;
        background: #fff;
        position: relative;

        .iconbox {
          width: 2rem;
          height: 1.4rem;
          margin: 0 auto;
          text-align: center;

          i {
            color: #d00914;
          }
        }

        .tit {
          color: #333;
          font-size: 0.4rem;
          text-align: center;
          padding: 0.63rem 0 0.56rem;
        }

        .line {
          width: 1.1rem;
          height: 2px;
          margin: 0 auto;
          margin-bottom: 0.6rem;
          background: #333;
        }

        .desc {
          color: #999;
          font-size: 0.35rem;
          line-height: 0.6rem;
          text-align: center;
        }

        .more {
          width: 2.7rem;
          height: 0.64rem;
          font-size: 0.36rem;
          line-height: 0.64rem;
          text-align: center;
          color: #fff;
          border: 1px solid #f72d2d;
          background: #f72d2d;
          position: absolute;
          left: 50%;
          bottom: 0.56rem;
          transform: translateX(-50%);
        }
      }
    }

    .mob-global {
      height: 11rem;
      background: #2a2120;
      background-repeat: no-repeat;
      background-size: auto 4.26rem;
      background-position: bottom;
      background-image: url("../../assets/mobel/home/glb.png");

      .content {
        width: 10rem;
        height: 7.2rem;
        margin: 0 auto;
        margin-top: 2rem;
        position: relative;

        .bar {
          width: 8.4rem;
          position: absolute;
          top: -1rem;
          left: 50%;
          transform: translateX(-50%);
        }

        .textbox {
          width: 6rem;
          height: 2.2rem;
          display: flex;

          position: absolute;
          top: -1.85rem;
          left: 50%;
          transform: translateX(-50%);

          // background: rgba(255, 255, 255, 0.3);
          .text-item {
            width: 3rem;
            text-align: center;

            .num {
              color: #fff;
              font-size: 0.6rem;
              margin-bottom: 0.8rem;
              line-height: 0.8rem;
            }

            .text {
              font-size: 0.38rem;
              color: #999;
            }
          }
        }

        .sign {
          width: 1.4rem;
          height: 1.9rem;
          line-height: 0.5rem;
          padding-top: 0.3rem;
          text-align: center;
          color: #fff;
          position: absolute;
          background-repeat: no-repeat;
          background-size: auto 1.8rem;
          background-position: bottom;
          background-image: url("../../assets/mobel/home/sign.png");
        }

        .spot {
          position: absolute;
          height: 7px;
          width: 7px;
          border-radius: 50%;
          background: #f2cc8f;

          &:before {
            content: "";
            position: absolute;
            height: 7px;
            width: 7px;
            border-radius: 50%;
            background: #f2cc8f;
            animation: ripplemob 1.5s infinite;
          }

          &:after {
            content: "";
            position: absolute;
            height: 7px;
            width: 7px;
            border-radius: 50%;
            background: #f2cc8f;
            animation: ripple 1.5s infinite;
            animation-delay: 0.3s;
          }
        }

        .spota {
          position: absolute;
          height: 7px;
          width: 7px;
          border-radius: 50%;
          background: #f2cc8f;

          &:before {
            content: "";
            position: absolute;
            height: 7px;
            width: 7px;
            border-radius: 50%;
            background: #f2cc8f;
            animation: ripplemob 2s infinite;
          }

          &:after {
            content: "";
            position: absolute;
            height: 7px;
            width: 7px;
            border-radius: 50%;
            background: #f2cc8f;
            animation: ripple 2s infinite;
            animation-delay: 0.4s;
          }
        }

        .spotb {
          position: absolute;
          height: 7px;
          width: 7px;
          border-radius: 50%;
          background: #f2cc8f;

          &:before {
            content: "";
            position: absolute;
            height: 7px;
            width: 7px;
            border-radius: 50%;
            background: #f2cc8f;
            animation: ripplemob 2.5s infinite;
          }

          &:after {
            content: "";
            position: absolute;
            height: 7px;
            width: 7px;
            border-radius: 50%;
            background: #f2cc8f;
            animation: ripple 2.5s infinite;
            animation-delay: 0.3s;
          }
        }

        .spotc {
          position: absolute;
          height: 7px;
          width: 7px;
          border-radius: 50%;
          background: #f2cc8f;

          &:before {
            content: "";
            position: absolute;
            height: 7px;
            width: 7px;
            border-radius: 50%;
            background: #f2cc8f;
            animation: ripplemob 3s infinite;
          }

          &:after {
            content: "";
            position: absolute;
            height: 7px;
            width: 7px;
            border-radius: 50%;
            background: #f2cc8f;
            animation: ripple 3s infinite;
            animation-delay: 0.6s;
          }
        }
      }
    }

    .mob-customers {
      width: 9.12rem;
      height: 4.2rem;
      margin: 0 auto;
      display: flex;
      display: -webkit-flex;
      flex-wrap: wrap;

      .customer-item {
        width: 3.04rem;
        height: 1.4rem;
        background: #fff;
        border: 1px solid #e1e1e1;
        border-top: none;
        border-left: none;
        display: flex;
        align-items: center;
        justify-content: center;

        &:nth-of-type(3n + 1) {
          border-left: 1px solid #e1e1e1;
        }

        &:nth-of-type(-n + 3) {
          border-top: 1px solid #e1e1e1;
        }
      }
    }

    .mob-news {
      width: 10rem;
      margin: 0 auto;

      // background: #ccc;
      .news-tab {
        height: 1.3rem;
        border-bottom: 1px solid #e1e1e1;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        position: relative;

        .tab-item {
          width: 3.2rem;
          height: 1.3rem;
          font-size: 0.48rem;
          line-height: 1.3rem;
          text-align: center;
        }

        .act {
          color: #cf111b;
          transition: 0.3s;
        }

        .underline {
          width: 3.2rem;
          height: 2px;
          background: #cf111b;
          position: absolute;
          bottom: -1px;
          transition: 0.3s;
        }
      }

      .news-content {
        min-height: 6rem;
        background: #f8f8f8;

        .news-item {
          padding: 0.4rem 0.5rem;
          border-bottom: 1px solid #e1e1e1;

          .date-tit {
            display: flex;
            display: -webkit-flex;
            align-items: center;
            margin-bottom: 0.2rem;

            .date {
              color: #666;
              width: 1.5rem;
              font-size: 0.34rem;
              // transform: scale(0.98);
              display: inline-block;
            }

            .tit {
              color: #333;
              width: 7.5rem;
              font-size: 0.38rem;
              display: inline-block;
            }
          }

          .desc {
            .text {
              font-size: 0.35rem;
            }
          }

          .tit,
          .text {
            white-space: nowrap;
            /*设置不换行*/
            overflow: hidden;
            /*设置隐藏*/
            text-overflow: ellipsis;
            /*设置隐藏部分为省略号*/
          }
        }
      }

      .news-more {
        height: 1.4rem;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        color: #999;

        span {
          display: inline-block;
          font-size: 0.36rem;
        }

        i {
          font-size: 0.34rem;
          margin-left: 0.1rem;
        }
      }
    }

    .mob-partners {
      width: 9.6rem;
      margin: 0 auto;
      padding-bottom: 1rem;

      .swiper-item {
        width: 2.2rem;
        height: 1rem;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        overflow: hidden;
        box-shadow: 0px 3px 6px 0px rgba(153, 153, 153, 0.3);
      }
    }

    .pagination-wrap {
      margin: 0 auto;
      padding-left: 20px;
      position: relative;

      .mobbanner-pagination {
        position: absolute;
        left: 50%;
        transform: (translateX(-50%));
        bottom: 6px;
        z-index: 1;

        /deep/.swiper-pagination-bullet {
          height: 3px;
          width: 0.6rem !important;
          margin-right: 0.1rem;
          opacity: 0.4;
          border-radius: 5px;
          background-color: #fff !important;
          outline: none;
          transition: all 0.3s;
        }

        /deep/.swiper-pagination-bullet-active {
          width: 0.6rem !important;
          opacity: 1;
          background-color: #c3191f !important;
          outline: none;
        }
      }
    }

    .video-outer {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 999;
      overflow: hidden;
      background-color: rgba(26, 26, 26, 0.65);
      -webkit-transition: background-color 0.3s ease-out;
      transition: background-color 0.3s ease-out;

      .video {
        position: fixed;
        width: 100%;
        height: auto;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background-color: #000;

        span {
          cursor: pointer;
          position: absolute;
          right: 15px;
          top: 0px;
          color: #fff;
          font-size: 30px;
          z-index: 999;
        }
      }
    }
  }
}

@media (-webkit-min-device-pixel-ratio: 2) {
  div {
    border-width: 0.5px;
  }
}

.jd-idc-title {
  margin-top: 0.2rem;
  width: 7rem;
  /*font-weight: bold;*/
  color: #003b94;
  font-size: 0.5rem;
  font-family: HYQiHei;
}
.jd-idc-sm-title {
  font-size: 0.3rem;
  margin-top: 0.5rem;
  font-family: Arial;
  color: #003b94;
}

.jd-idc-btn {
  border: 1px solid #003b94;
  padding: 0.1rem 0.3rem;
  color: #003b94;
  margin-top: 1rem;
  cursor: pointer;
  font-size: 0.3rem;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/view/home/index.vue